<mat-card style="width: max-content; max-width: 100%; box-sizing: border-box;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Lab Test Requests
                </mat-card-title>
                <mat-card-subtitle>
                    Find, search and filter requested lab tests
                </mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="justify-content: flex-end; flex: 1 1 auto;">
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>

                @if((canAddRequests$ | async) && patientId !== null) {
                <a mat-flat-button class="" (click)="encounterService.addServiceRequest(patientId, 'Laboratory')">
                    <mat-icon>add</mat-icon>
                    Add Lab Request
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>

        <!-- Combined Search and Filters Section -->
        <app-table-header [searchableFields]="searchableFields" [selectedSearchField]="selectedSearchField"
            (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
        </app-table-header>

        <mat-divider></mat-divider>

        <!-- Table or Empty State -->
        @if (loading$ | async) {
        <div style="display: flex; justify-content: center; padding: 40px;">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        } @else {
        @if (tableDataLevel2 | async; as data) {
            @if (data.length > 0) {
            <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

            <!--name - coding.code.display-->
            <ng-container matColumnDef="authoredOn">

                <th mat-header-cell *matHeaderCellDef mat-sort-header="authoredOn" sortActionDescription="Sort by Date">
                    Date Requested
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.authoredOn){
                    <div class="pt-3">
                        {{element.authoredOn | date : "mediumDate"}}
                    </div>

                    <div class="pb-3 subtitle-text-color-2 small-subtitle">
                        {{element.authoredOn | date : "shortTime"}}
                    </div>
                    }@else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                    <!-- {{element | json}} -->
                </td>

            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="status" sortActionDescription="Sort by status">
                    Status
                </th>
                <td mat-cell *matCellDef="let element">
                    <div [appChips]="element.status" [fontSize]="'14px'">


                    </div>

                </td>
            </ng-container>


            <ng-container matColumnDef="requisition">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="requisition"
                    sortActionDescription="Sort by requisition">
                    Group Id
                </th>

                <td mat-cell *matCellDef="let element ; let i = index;"
                    style="max-width: 135px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [ngClass]="{'nob':element.requisition && sortedWithRequisitionKeys.length &&
                    sortedWithRequisitionKeys.includes(element.requisition?.value),
                    'not': (element.requisition && sortedWithRequisitionKeys.length) && (  i == tableDataLevel2.getValue().length - 1 ||
                    !(tableDataLevel2.getValue()[i+1].requisition) ||
                    sortedWithRequisition[element.requisition.value] !==
                    sortedWithRequisition[tableDataLevel2.getValue()[i+1].requisition?.value])

                    }">
                    @if(element.requisition && element.requisition.value) {
                    {{
                    i == 0 || !(tableDataLevel2.getValue()[i-1].requisition) ||
                    sortedWithRequisition[element.requisition.value] !==
                    sortedWithRequisition[tableDataLevel2.getValue()[i-1].requisition?.value]
                    ? element.requisition.value : ""
                    }}
                    }@else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>

            </ng-container>
            <ng-container matColumnDef="groupReport">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="groupReport"
                    sortActionDescription="Sort by group report">
                    Group Report
                </th>

                <td mat-cell *matCellDef="let element ; let i = index;" [ngClass]="{'nob-last':element.requisition && sortedWithRequisitionKeys.length &&
                    sortedWithRequisitionKeys.includes(element.requisition?.value),
                    'not-last': (element.requisition && sortedWithRequisitionKeys.length) && (  i == tableDataLevel2.getValue().length - 1 ||
                    !(tableDataLevel2.getValue()[i+1].requisition) ||
                    sortedWithRequisition[element.requisition.value] !==
                    sortedWithRequisition[tableDataLevel2.getValue()[i+1].requisition?.value])

                    }">
                    @if(element.requisition && element.requisition.value) {
                    @if(
                    i == 0 || !(tableDataLevel2.getValue()[i-1].requisition) ||
                    sortedWithRequisition[element.requisition.value] !==
                    sortedWithRequisition[tableDataLevel2.getValue()[i-1].requisition?.value]
                    )
                    {

                    <!--mat-menu for report and generating order -->
                    @if(auth.can('labRequest', 'viewAll') || auth.can('labRequest', 'add')) {
                    <a mat-button [matMenuTriggerFor]="groupMenu">Group Actions</a>
                    <mat-menu #groupMenu="matMenu">
                        @if(auth.can('labRequest', 'viewAll')) {
                        <button mat-menu-item (click)="printLabGroup(element.requisition?.value)">
                            <mat-icon>print</mat-icon>
                            Print Lab Group
                        </button>
                        }
                        @if(auth.can('labRequest', 'update')) {
                        <button mat-menu-item (click)="showGroupReport(element.requisition?.value)">
                            <mat-icon>book</mat-icon>
                            Diagnostic Report
                        </button>
                        }
                        <!-- @if(auth.can('labRequest', 'add')) {
                        <button mat-menu-item>
                            <mat-icon>assignment</mat-icon>
                            Generate Order
                        </button>
                        } -->

                    </mat-menu>
                    }


                    }@else{}

                    }@else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>

            </ng-container>


            <!--dateRecorded - recordedDateTime -->

            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="subject" sortActionDescription="Sort by Subject">
                    Patient
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element.subject){
                    <span [appReferenceDisplay]="element.subject?.reference" InstantfetchAndRepace="true"></span>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>



            <!--category - category.coding.display -->



            <ng-container matColumnDef="priority">

                <th mat-header-cell *matHeaderCellDef mat-sort-header="priority"
                    sortActionDescription="Sort by Priority">
                    Priority
                </th>
                <td mat-cell *matCellDef="let element">
                    @let priority = element.priority?.display || element.priority;
                    <span
                        [ngClass]="{'grey': true, 'round': true, 'yellowbg':priority === 'ASAP', 'redbg':priority=== 'emergency'}">
                        {{priority | titlecase | na}}
                    </span>
                </td>
            </ng-container>

            <!--verificationStatus - verificationStatus.coding[0].code   -->
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="code" sortActionDescription="Sort by code">
                    Test
                </th>
                <td mat-cell *matCellDef="let element; let i=index;" #td class="restrict-width">
                    @if(element.code?.concept || element.code?.reference ){

                    <div class="g-just-flex gap-0 my-12 link-group"
                        style="justify-content: flex-start; align-items: center;">
                        <div class="g-just-flex gap-5 link-group-words"
                            style="justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                            <div class="top">
                                {{element.code | codeableConcept2 | na}}


                            </div>
                            <!-- {{element | json}} -->
                            @if(element.available){
                            <div class="app-emphasis-badge"
                                [ngClass]="{'is-available': element.available === 'Available', 'is-unavailable': element.available !== 'Available'}">
                                {{element.available}}
                            </div>
                            }
                            @if(isLinkObj['medication'] && isLinkObj['medication'].get(i)) {
                            @if(false){
                            <div class="bottom subtitle-text-color-2 link-group-icon">
                                @if((element.medication.reference | fetchFromReference : 'code': 'coding': 0 : 'display'
                                )| async){
                                {{element.medication.reference | fetchFromReference : 'code': 'coding': 0 : 'display' |
                                async}}
                                }@else{
                                <div style="width:10px; height: 10px;">
                                    <mat-progress-spinner mode="indeterminate"
                                        style="width:10px !important; height: 10px !important">

                                    </mat-progress-spinner>
                                </div>

                                }


                            </div>
                            }
                            }
                        </div>
                        <div>
                            @if(false){
                            @if(isLinkObj['medication'] && isLinkObj['medication'].get(i)) {

                            <div (click)="alltds(td)">


                                <mat-expansion-panel hideToggle="true" class="detail-base" style="box-shadow: none;">
                                    <mat-expansion-panel-header style="margin: 0px; padding: 0px;">
                                        <mat-panel-title style="margin-right: 0px;">
                                            <mat-icon color="subtitle-text-color-2"
                                                style="margin: 0px; padding: 0px;">chevron_right</mat-icon>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <!-- <span>jjjj</span> -->
                                        <div style="width: 250px;">
                                            <app-detail-base
                                                [url]="isLinkObj['medication'].get(i)??''"></app-detail-base>
                                        </div>
                                    </ng-template>
                                </mat-expansion-panel>
                            </div>
                            }
                            }
                        </div>
                    </div>

                    }@else if(element.code?.coding && element.code?.coding?.length > 0) {
                    <div class="g-just-flex gap-0 my-12 link-group"
                        style="justify-content: flex-start; align-items: center;">
                        <div class="g-just-flex gap-5 link-group-words"
                            style="justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                            <div class="top">
                                {{element.code | codeableConcept2 | na}}


                            </div>
                            @if(element.available){
                            <span [appEmphasis]="element.available" fontSize="11px">{{element.available}}

                            </span>
                            <!-- <div class="app-emphasis-badge"
                                [ngClass]="{'is-available': element.available === 'Available', 'is-unavailable': element.available !== 'Available'}">
                                {{element.available}}
                            </div> -->
                            }
                            @if(isLinkObj['medication'] && isLinkObj['medication'].get(i)) {
                            <div class="bottom subtitle-text-color-2 link-group-icon">
                                @if((element.medication.reference | fetchFromReference : 'code': 'coding': 0 : 'display'
                                )| async){
                                {{element.medication.reference | fetchFromReference : 'code': 'coding': 0 : 'display' |
                                async}}
                                }@else{
                                <div style="width:10px; height: 10px;">
                                    <mat-progress-spinner mode="indeterminate"
                                        style="width:10px !important; height: 10px !important">

                                    </mat-progress-spinner>
                                </div>

                                }


                            </div>
                            }
                        </div>
                        <div>
                            <!-- @if(isLinkObj['medication'] && isLinkObj['medication'].get(i)) {
                            <div (click)="alltds(td)">


                                <mat-expansion-panel hideToggle="true" class="detail-base" style="box-shadow: none;">
                                    <mat-expansion-panel-header style="margin: 0px; padding: 0px;">
                                        <mat-panel-title style="margin-right: 0px;">
                                            <mat-icon color="subtitle-text-color-2"
                                                style="margin: 0px; padding: 0px;">chevron_right</mat-icon>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>

                                        <div style="width: 250px;">
                                            <app-detail-base
                                                [url]="isLinkObj['medication'].get(i)??''"></app-detail-base>
                                        </div>
                                    </ng-template>
                                </mat-expansion-panel>
                            </div>
                            } -->
                        </div>
                    </div>
                    }@else if(element.code?.text){
                    <div class="top"> {{element.code.text}} </div>
                    @if(element.available){
                    <span [appEmphasis]="element.available" fontSize="11px">{{element.available}}

                    </span>
                    }
                    }@else {
                    <span class="subtitle-text-color-2">N/A</span>}

                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                    Actions
                </th>
                <td mat-cell *matCellDef="let element">

                    <mat-menu #mm="matMenu">
                        <a mat-menu-item>
                            <a mat-button (click)="showRow(element)">
                                Details
                            </a>
                        </a>
                        <!-- <a mat-menu-item>
                            <a mat-button (click)="showSpecimenForThisTest()">
                                Specimen
                            </a>
                        </a>
                        <a mat-menu-item>
                            <a mat-button (click)="addLabResults(patientId || '')">
                                Add Results
                            </a>
                        </a>
                        <a mat-menu-item (click)="showReport()">
                            <a mat-button>
                                Report
                            </a>
                        </a>
                        <a mat-menu-item>
                            <a mat-button>
                                Generate Order
                            </a>
                        </a> -->

                    </mat-menu>
                    <a [mat-menu-trigger-for]="mm">
                        <mat-icon style="color: var(--mat-sys-primary)">more_vert</mat-icon>
                    </a>


                </td>
            </ng-container>





            <!--clinicalStatus - clinicalStatus.coding[0].code -->


            <tr mat-header-row *matHeaderRowDef="labRequestsDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns:labRequestsDisplayedColumns; let dataIndex = index;"></tr>
            </table>
            } @else {
            <app-empty-state [icon]="'MEDICAL_SERVICES'" [title]="'Lab Requests Not Available'"
                [subtitle]="'No lab requests have been made for this patient yet.'">
            </app-empty-state>
            }
        }
    }

        <mat-paginator [length]="total$ | async" [pageSize]="pageSize" [pageIndex]="paginatorPageIndex"
            [pageSizeOptions]="[10, 25, 50, 100]" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
    </mat-card-content>
</mat-card>